import * as actionTypes from './actionTypes';
import axios from '../../axios-api';


export const getVersions = () => {
    return dispatch => {
        axios.get('getVersions.php')
            .then(response => {
                dispatch(getVersionsSuccess(response.data));        
            })
            .catch( error => {
            });
    };
};

export const getVersionsSuccess = (versions) => {
    return {
        type: actionTypes.GET_VERSIONS_SUCCESS,
        versions: versions
    };
};

export const updateAdminSimpleVariable = (variableName, newValue) => {
    return {
        type: actionTypes.UPDATE_ADMIN_SIMPLE_VARIABLE,
        variableName: variableName,
        newValue: newValue
    };
};

export const createNewVersion = (postData) => {
    return dispatch => {
        axios.post('createNewVersion.php', {postData})
            .then(response => {
                dispatch(createVersionSuccess(response.data));        
            })
            .catch( error => {
            });
    };
};

export const createVersionSuccess = (data) => {
    return {
        type: actionTypes.CREATE_VERSION_SUCCESS,
        data: data
    };
};

export const clearVersion = () => {
    return {
        type: actionTypes.CLEAR_VERSION
    };
};

export const changeDatabaseVersion = (postData) => {
    return dispatch => {
        axios.post('changeDatabaseVersion.php', {postData})
            .then(response => {
                console.log(response.data)
                dispatch(updateAdminSimpleVariable("changedVersion", true));        
            })
            .catch( error => {
            });
    };
};